import React from 'react';
import PropTypes from 'prop-types';
import colors from 'assets/styles/jsVariables/colors';
import './TitleAndLabel.scss';

const TitleAndLabel = React.forwardRef((props, ref) => {
  const {
    editMode, tabIndex,
    value, handleChange,
    displayValue, labelStyle, title,
    disabled, validationMsg, onEnter
  } = props;

  const getClassName = (_editMode, _validationMsg) => {
    const _className = _editMode ?
      `${_validationMsg ? 'EditableLabel__TitleAndLabel__EditInput--Red' : 'EditableLabel__TitleAndLabel__EditInput'}` :
      'EditableLabel__TitleAndLabel__Input';
    return _className;
  };

  const getValue = (_editMode) => {
    const _value = _editMode ? value : displayValue;
    return _value;
  };

  const getId = (_editMode) => {
    const _id = _editMode ? `inputEditableLabel-${tabIndex}` : '';
    return _id;
  };

  const getStyle = (_editMode) => {
    let _style = {};
    if (!_editMode) {
      _style = {
        ...(
          disabled ? {
            color: colors.lightGrey,
            WebkitTextFillColor: colors.lightGrey
          } : null
        ),
        ...labelStyle
      };
    }
    return _style;
  };

  const className = getClassName(editMode, validationMsg);
  const inputValue = getValue(editMode);
  const style = getStyle(editMode);
  const id = getId(editMode);

  return (
    <div>
      <div className="EditableLabel__TitleAndLabel__Title">
        {title}
      </div>
      {
        editMode ?
          <input
            id={id}
            value={inputValue}
            disabled={disabled}
            type="text"
            ref={ref}
            onChange={e => handleChange(e.target.value)}
            onKeyUp={(e) => {
              if (e.keyCode === 13) {
                onEnter();
              }
            }}
            className={className}
            style={style}
          />
        :
          <div className={className} style={{ color: disabled ? colors.lightGrey : '' }}>
            <span>{inputValue}</span>
          </div>
      }
    </div>
  );
});

export default TitleAndLabel;

TitleAndLabel.propTypes = {
  editMode: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  labelStyle: PropTypes.object.isRequired,
  tabIndex: PropTypes.string.isRequired,
  displayValue: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  validationMsg: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  onEnter: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/EditableLabel/TitleAndLabel.jsx